









































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import { UserModel, UserRoleType, UserStatus } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { PlusIcon } from 'vue-feather-icons';
import RoleSelect from '@/components/common/selects/RoleSelect.vue';
import UserSpecialTypeSelect from '@/components/common/selects/UserSpecialTypeSelect.vue';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import UserStatusSelect from '@/components/common/selects/UserStatusSelect.vue';
import ResendCodeLink from '@/views/pages/settings/agency/ResendCodeLink.vue';

@Component({
  components: {
    ResendCodeLink,
    UserStatusSelect,
    FormInputPassword,
    UserSpecialTypeSelect,
    RoleSelect,
    FormTextarea,
    TagSelect,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
  },
})
export default class UserForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: UserModel;

  @Prop({ required: true, type: Object })
  readonly errors!: UserModel;

  @Prop({ required: false, type: String, default: () => 'create' })
  readonly mode!: 'create' | 'edit';

  @Prop({ required: false, type: Boolean, default: false })
  readonly fromAdmin!: boolean;

  async mounted() {
    //
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }
  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get isGuestUser() {
    return this.value.role?.type === UserRoleType.GUEST;
  }

  get isStatusPending() {
    return this.value.status === UserStatus.PENDING;
  }
}
